"use strict";
(() => {
  // frontend/config/theme.js
  var settings = window.KROWN.settings;
  var STORE_DOMAIN = settings.store_domain;
  var PUBLIC_STOREFRONT_TOKEN = settings.storefront_api_key;
  var CLIENT_ID = settings.client_id;
  var SHOP_ID = settings.shop_id;
  var ADMIN_GRAPHQL_PROXY_URL = settings.admin_graphql_proxy_url;
  var CALLBACK_URL = window.location.origin;
  var routes = settings.routes;
  var locales = settings.locales;
  var symbols = settings.symbols;
  var moneyFormat = settings.shop_money_format;

  // frontend/lib/utils.js
  async function generateCodeVerifier() {
    const rando = generateRandomCode();
    return base64UrlEncode(rando);
  }
  async function generateCodeChallenge(codeVerifier) {
    const digestOp = await crypto.subtle.digest(
      { name: "SHA-256" },
      new TextEncoder().encode(codeVerifier)
    );
    const hash = convertBufferToString(digestOp);
    return base64UrlEncode(hash);
  }
  function generateRandomCode() {
    const array = new Uint8Array(32);
    crypto.getRandomValues(array);
    return String.fromCharCode.apply(null, Array.from(array));
  }
  function base64UrlEncode(str) {
    const base64 = btoa(str);
    return base64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
  }
  function convertBufferToString(hash) {
    const uintArray = new Uint8Array(hash);
    const numberArray = Array.from(uintArray);
    return String.fromCharCode(...numberArray);
  }
  async function generateState() {
    const timestamp = Date.now().toString();
    const randomString = Math.random().toString(36).substring(2);
    return timestamp + randomString;
  }
  async function generateNonce(length) {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let nonce = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      nonce += characters.charAt(randomIndex);
    }
    return nonce;
  }

  // frontend/lib/customer.js
  async function authorization() {
    const authorizationRequestUrl = new URL(`https://shopify.com/${SHOP_ID}/auth/oauth/authorize`);
    const state = await generateState();
    const nonce = await generateNonce(16);
    authorizationRequestUrl.searchParams.append(
      "scope",
      "openid email https://api.customers.com/auth/customer.graphql"
    );
    authorizationRequestUrl.searchParams.append("client_id", CLIENT_ID);
    authorizationRequestUrl.searchParams.append("response_type", "code");
    authorizationRequestUrl.searchParams.append("redirect_uri", CALLBACK_URL);
    authorizationRequestUrl.searchParams.append("state", state);
    authorizationRequestUrl.searchParams.append("nonce", nonce);
    const verifier = await generateCodeVerifier();
    const challenge = await generateCodeChallenge(verifier);
    localStorage.setItem("code_verifier", verifier);
    authorizationRequestUrl.searchParams.append("code_challenge", challenge);
    authorizationRequestUrl.searchParams.append("code_challenge_method", "S256");
    window.location.href = authorizationRequestUrl.toString();
  }

  // frontend/modules/customers-auth.js
  var CustomersAuth = class extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.addEventListener("click", this.handleAuthorization.bind(this));
      this.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;
        event.preventDefault();
        this.handleAuthorization();
      });
    }
    handleAuthorization() {
      authorization();
    }
  };
  if (typeof customElements.get("customers-auth") == "undefined") {
    customElements.define("customers-auth", CustomersAuth);
  }
})();
